import { Lock } from 'lucide-react';
import { useState, type FormEvent } from 'react';
import { Navigate } from 'react-router-dom';
import { Button } from '@/components/ui/Button';
import { useAuth } from '@/hooks/useAuth';

export function AdminLoginPage() {
  const { session, signIn } = useAuth();
  const [email, setEmail] = useState('admin@eldivergente.ar');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');

  if (session) {
    return <Navigate to="/admin" replace />;
  }

  async function handleSubmit(event: FormEvent<HTMLFormElement>) {
    event.preventDefault();
    const ok = await signIn(email, password);
    setError(ok ? '' : 'Credenciales invalidas');
  }

  return (
    <main className="safe-px grid min-h-dvh place-items-center bg-black text-white">
      <form onSubmit={handleSubmit} className="w-full max-w-sm rounded bg-divergent-surface p-6 shadow-app">
        <div className="mb-6 grid size-12 place-items-center rounded bg-divergent-yellow text-black">
          <Lock size={24} aria-hidden="true" />
        </div>
        <h1 className="text-2xl font-black">Admin</h1>
        <div className="mt-6 space-y-3">
          <label className="block text-sm text-white/70">
            Email
            <input
              type="email"
              value={email}
              onChange={(event) => setEmail(event.target.value)}
              className="mt-2 min-h-11 w-full rounded border border-white/10 bg-black px-3 text-white outline-none focus:border-divergent-yellow"
              required
            />
          </label>
          <label className="block text-sm text-white/70">
            Password
            <input
              type="password"
              value={password}
              onChange={(event) => setPassword(event.target.value)}
              className="mt-2 min-h-11 w-full rounded border border-white/10 bg-black px-3 text-white outline-none focus:border-divergent-yellow"
              minLength={8}
              required
            />
          </label>
        </div>
        {error ? <p className="mt-3 text-sm text-red-300">{error}</p> : null}
        <Button className="mt-6 w-full" type="submit">
          Entrar
        </Button>
      </form>
    </main>
  );
}
